import { getVenuePresets } from '@/domain/project-venue-presets/actions/get-venue-presets.action.ts';
import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  presetForm: VenuePreset;
};

export const createProjectVenuePreset = createAppAsyncThunk(
  'projectVenue/createProjectVenuePreset',
  async (
    params: Params,
    { extra: { projectVenuePresetsGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await projectVenuePresetsGateway.create(params.presetForm);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getVenuePresets());
    } catch (error) {
      const errorMessageKey = translate('CreatePreset.Message.error');
      showSnackbarError(snackbarGateway, errorMessageKey);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreatePreset.Message.success'));
}

function showSnackbarError(
  snackbarGateway: SnackbarGateway,
  errorMessage: string,
) {
  snackbarGateway.error(errorMessage);
}
